export const GET_MEMBER_LOGIN_REQUEST = "GET_MEMBER_LOGIN_REQUEST"
export const GET_MEMBER_LOGIN_SUCCESS = "GET_MEMBER_LOGIN_SUCCESS"